export const MANIPULATE_OBJECTIVES_TYPES = {
  MAPPED_TABS: "mappedTabs",
};

export const MANIPULATE_OBJECTIVES_INITIAL_STATE: ManipulateObjectivesState = {
  mappedTabs: null,
};

export interface Tab {
  id: string;
  label: string;
}

export interface ManipulateObjectivesState {
  mappedTabs: Tab[] | null;
}

export interface Action {
  type: string;
  payload: any;
}

export const manipulateObjectivesReducer = (
  state = MANIPULATE_OBJECTIVES_INITIAL_STATE,
  action: Action
): ManipulateObjectivesState => {
  switch (action.type) {
    case MANIPULATE_OBJECTIVES_TYPES.MAPPED_TABS:
      return { ...state, mappedTabs: action.payload };

    default:
      return state;
  }
};
